import dayjs from 'dayjs'
import { isEmpty, omit } from 'lodash-es'

export enum Category {
  ChangeSalary = 'ChangeSalary'
}
export const Config: { [index: string]: any } = {
  [Category.ChangeSalary]: {
    control: (props: any) => {
      const { options, onChange, typeName, label, required, disabled, placeholder } = props
      return [
        {
          type: 'Select',
          formItemProps: {
            name: typeName ?? 'salary_structure_template_id',
            label: label ?? '薪酬结构模版',
            required: required ?? true,
            disabled,
            style: {
              marginBottom: 0
            }
          },
          elementProps: {
            style: {
              marginBottom: 0
            },
            placeholder: placeholder ?? '请选择',
            allowClear: true,
            fieldNames: {
              value: 'id',
              label: 'name'
            },
            options,
            onChange
          }
        }
      ]
    },
    dict: {
      name: 'DictSalaryTemplate',
      url: '/salary/base/templates',
      method: 'post',
      param: {
        paged: false,
        enable_status: 1
      },
      // value需要为空
      fieldNames: { label: 'name', value: 'undefined' },
      isForce: true
    }
  }
}
const OmitSalaryKeys = [
  'enable_date_type',
  'enable_date',
  'salary_structure_template_id',
  'salary_details',
  'old_salary_structure_template_id',
  'old_salary_object',
  'old_salary_details',
  'reason_type',
  'remark'
]
export const omitSalaryKeys = (params: any) => {
  return omit(params, OmitSalaryKeys)
}
export const transformSalaryToArray = (templateId: string, salary: any, zidianStore: any) => {
  const options = zidianStore.getOptions('DictSalaryTemplate') || []
  const list = options.find((x: any) => x.id === templateId)?.item_dtos || []
  return isEmpty(salary)
    ? []
    : Array.isArray(salary)
      ? salary
      : Object.entries(salary).map(([key, value]) => ({
          code: key,
          name: list.find((x: any) => x.code === key)?.name,
          value: value
        }))
}
export const transformSalaryToExtend = (params: any, zidianStore: any) => {
  const extended_param: any = !params?.extended_param ? {} : params?.extended_param
  if (params?.salary_structure_template_id) {
    extended_param.enable_date_type = params?.enable_date_type
    extended_param.enable_date = params?.enable_date
      ? dayjs(params?.enable_date).format('YYYY-MM-DD')
      : null
    extended_param.old_salary_structure_template_id = params?.old_salary_structure_template_id
    extended_param.old_salary_details = transformSalaryToArray(
      params?.old_salary_structure_template_id,
      params?.old_salary_details,
      zidianStore
    )
    extended_param.salary_structure_template_id = params?.salary_structure_template_id
    extended_param.salary_details = transformSalaryToArray(
      params?.salary_structure_template_id,
      params?.salary_details,
      zidianStore
    )
    extended_param.reason_type = params?.reason_type
    extended_param.remark = params?.remark
  } else if (params?.headcount_id) {
    extended_param.headcount_id = params?.headcount_id?.[0]?.id
    extended_param.original_headcount = params?.original_headcount
    extended_param.headcount_change = params?.headcount_change
    extended_param.reason = params?.reason
  }
  return extended_param
}
export const convertSalaryToExtend = (params: any) => {
  const extended_param: any = !params?.extended_param ? {} : params?.extended_param
  if (params?.salary_structure_template_id) {
    extended_param.enable_date_type = params?.enable_date_type
    extended_param.enable_date = params?.enable_date
      ? dayjs(params?.enable_date).format('YYYY-MM-DD')
      : null
    extended_param.old_salary_structure_template_id = params?.old_salary_structure_template_id
    extended_param.old_salary_details = params?.old_salary_details?.reduce(
      (acc: any, curr: any) => {
        acc[curr.code] = curr.value
        return acc
      },
      {}
    )
    extended_param.old_salary_object = {
      old_salary_structure_template_id: params?.old_salary_structure_template_id,
      old_salary_details: params?.old_salary_details
    }
    extended_param.salary_structure_template_id = params?.salary_structure_template_id
    extended_param.salary_details = params?.salary_details?.reduce((acc: any, curr: any) => {
      acc[curr.code] = curr.value
      return acc
    }, {})
    extended_param.salary_object = {
      salary_structure_template_id: params?.salary_structure_template_id,
      salary_details: params?.salary_details
    }
    extended_param.reason_type = params?.reason_type
    extended_param.remark = params?.remark
  }
  return extended_param
}
